export const SENSOR_ONLINE_THRESHOLD_MS = 30 * 60 * 1000;

export const latestSensorMeasurementTimestamp = (sensor) => {
  const timestamps = (Array.isArray(sensor?.data) ? sensor.data : [])
    .flatMap((metric) =>
      Array.isArray(metric?.measurements) ? metric.measurements : []
    )
    .map((measurement) => {
      const value = measurement?.date;
      if (value === null || value === undefined || value === "") return NaN;
      return new Date(value).getTime();
    })
    .filter(Number.isFinite);

  return timestamps.length > 0 ? Math.max(...timestamps) : null;
};

export const sensorStatusAt = (lastMeasurementTimestamp, now = Date.now()) => {
  if (!Number.isFinite(lastMeasurementTimestamp)) return "offline";

  return now - lastMeasurementTimestamp <= SENSOR_ONLINE_THRESHOLD_MS
    ? "online"
    : "offline";
};

export const enrichSensorFeatures = (features, now = Date.now()) => {
  (Array.isArray(features) ? features : []).forEach((feature) => {
    const apiSensor = feature.get("apiSensor");
    const timestamp = latestSensorMeasurementTimestamp(apiSensor);

    feature.setProperties({
      lastMeasurementAt:
        timestamp == null ? null : new Date(timestamp).toISOString(),
      status: sensorStatusAt(timestamp, now),
    });
  });

  return features;
};
